import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import Header from "../Header";
import { useLocation } from "react-router-dom";
import { useOrderStore } from "../../store/useOrderStore";
import Loader from "../loader/Loader";
import ProductDetailsTable from "../ProductDetailsTable";
import { formatDate } from "../formateDate";

const OrderDetails = () => {
    // const { order, user, productDetails } = dummyOrder;
    const [order, setOrder] = useState({})
    const [user, setUser] = useState({})
    const [itemID, setItemId] = useState(null)
    const [loading, setLoading] = useState(false)
    const [productDetails, setProductDetails] = useState([])

    const { dowloadOrderDetail } = useOrderStore()
    const location = useLocation();
    const { getOrderById } = useOrderStore()

    const getOrderByIdFunction = async (id) => {
        try {
            setLoading(true)
            const res = await getOrderById(id)
            if (res) {
                setOrder(res?.ref)
                setUser(res?.user)
                setProductDetails(res?.productDetails)
            }
            setLoading(false)
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    const handleDowload = async () => {
        setLoading(true)
        await dowloadOrderDetail(itemID)
        setLoading(false)
    }

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get("id");
        console.log(id)
        setItemId(id)
        getOrderByIdFunction(id)
    }, [location.search])
    return (

        <div id="dashboard-root"
            className="flex min-h-[1000px] w-full">
            <Loader loading={loading} />
            {/* <!-- sidebar --> */}
            <Sidebar />
            {/* <!-- Main Content --> */}
            <main id="main-content" className="flex-1 px-10 py-8">
                {/* <!-- Header --> */}
                <Header title="Order Summary" />
                <div className="max-w-5xl mx-auto p-6 bg-white rounded-2xl shadow-md space-y-6 text-sm text-gray-700">
                    {/* Order Summary */}
                    {/* <h2 className="text-2xl font-bold text-gray-900">Order Summary</h2> */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <Detail label="Order ID" value={order?.orderId} />
                        <Detail label="Database ID" value={order?._id} />
                        <Detail label="Payment Status" value={order?.paymentStatus} />
                        <Detail label="Order Status" value={order?.orderStatus} />
                        {/* <Detail label="Is Delivered" value={order?.isDelivered ? "Yes" : "No"} /> */}
                        <Detail label="Created At" value={formatDate(order?.createdAt)} />
                        <Detail label="Updated At" value={formatDate(order?.updatedAt)} />
                        <Detail label="Total (Before Coupon)" value={`$${order?.totalAmountBeforeCoupon}`} />
                        <Detail label="Total (After Coupon)" value={`$${order?.totalAmountAfterCoupon}`} />
                    </div>

                    {/* User Info */}
                    <div className="flex justify-between  border-t">
                        <div className="pt-6">
                            <h3 className="text-lg font-semibold mb-2">User Info</h3>
                            <div className="flex items-center space-x-4">
                                <img src={user?.avatar} alt={user?.userName} className="w-16 h-16 rounded-full object-cover" />
                                <div>
                                    <p><strong>Username:</strong> {user?.userName}</p>
                                    <p><strong>Full Name:</strong> {user?.fullName}</p>
                                    <p><strong>Email:</strong> {user?.email}</p>
                                </div>
                            </div>
                        </div>

                        {/* Shipping Address */}
                        <div className="pt-6">
                            <h3 className="text-lg font-semibold mb-2">Shipping Address</h3>
                            <div className="space-y-1">
                                <p><strong>Name:</strong> {order?.shippingAddress?.fullName}</p>
                                <p><strong>Phone:</strong> {order?.shippingAddress?.phone}</p>
                                <p><strong>Street:</strong> {order?.shippingAddress?.streetAddress}</p>
                                <p><strong>Apartment:</strong> {order?.shippingAddress?.apartment}</p>
                                <p><strong>City:</strong> {order?.shippingAddress?.city}</p>
                                <p><strong>State:</strong> {order?.shippingAddress?.state}</p>
                                <p><strong>Zip Code:</strong> {order?.shippingAddress?.zipCode}</p>
                                <p><strong>Country:</strong> {order?.shippingAddress?.country || "N/A"}</p>
                            </div>
                        </div>
                    </div>
                    <div className="p-6">
                        {/* other sections like user info, order summary, etc. */}
                        <ProductDetailsTable productDetails={productDetails} />
                    </div>
                </div>
                <button
                    onClick={() => handleDowload()}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#007bff',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                        transition: 'background-color 0.3s ease',
                        marginBottom: '20px',
                    }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = '#0056b3')}
                    onMouseOut={(e) => (e.target.style.backgroundColor = '#007bff')}
                >
                    Download
                </button>
            </main>
        </div>

    );
};

const Detail = ({ label, value }) => (
    <div>
        <p className="text-xs text-gray-500">{label}</p>
        <p className="font-medium">{value}</p>
    </div>
);

export default OrderDetails;
